import styled from 'styled-components';

import { NewFilterLabel } from '@spa/shared/components/Labels/styles';
import { Container as SliderContainer } from '@spa/shared/components/Slider/styles';
import { Wrapper as Counter } from '@spa/shared/components/Counter/styles';
import { mediaMin } from '@spa/shared/theme';

export const Container = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  padding-inline: 10px;
  height: 50px;
  margin-bottom: ${props => props.theme.space(2)};
  background: ${props => props.theme.filter.background};
  border-radius: 4px;
  box-shadow: 0px 1px 2px 0px #00000014;

  & + div {
    margin-top: 0;
  }

  ${SliderContainer} {
    height: 5px;
    width: 151px;
    margin-left: auto;
  }

  svg {
    width: 20px;
    margin-right: ${props => props.theme.space(2)};

    g {
      stroke: ${props => props.theme.filter.color};
    }
  }

  span {
    display: flex;
    align-items: center;
  }

  label {
    text-align: left;
    display: flex;
    min-width: 85px;

    ${mediaMin.mediumBreakpoint`
      font-size: ${props => props.theme.rem(14)};
      color: ${props => props.theme.colors.paleSky};
    `}
  }

  ${NewFilterLabel} {
    margin-left: auto;
  }

  ${Counter} {
    span {
      font-size: ${props => props.theme.rem(14)};
      color: ${props => props.theme.colors.paleSky};
    }
  }

  ${mediaMin.smallBreakpoint`
    margin: 0;
    padding: ${props => props.theme.space(4)};
  `}
`;
